<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CInput
          label="First Name"
          placeholder=""
          v-model="form.first_name"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="Last Name"
          placeholder=""
          v-model="form.last_name"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CSelect
          label="Type"
          placeholder=""
          :value.sync="form.type"
          :options="contact_types"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="Phone"
          placeholder=""
          v-model="form.phone"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <!-- <CRow>
      <CCol sm="12">
        <CInput
          label="Cell"
          placeholder=""
          v-model="form.mobile"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <CInput
          label="Fax"
          placeholder=""
          v-model="form.fax"
          :horizontal="true"
        />
      </CCol>
    </CRow>-->
    <CRow>
      <CCol sm="12">
        <CInput
          label="Email"
          placeholder=""
          v-model="form.email"
          :horizontal="true"
        />
      </CCol>
    </CRow>
    <CRow class="mb-5">
      <CCol sm="3"></CCol>
      <CCol sm="9">
        <CInputCheckbox
          label="Restricted access: cannot login into portal and will not receive email notifications."
          placeholder=""
          v-model="form.restrictAccess"
          :horizontal="true"
          :addLabelClasses="['font-weight-bold']"
          required
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6"></CCol>
      <CCol sm="3">
        <CButton block @click="$emit('cancel')" color="default" class="btn-square">Cancel</CButton>
      </CCol>
      <CCol sm="3">
        <b-overlay spinner-small :show="saving">
          <CButton block class="btn-sf btn-square" @click="save">Invite</CButton>
        </b-overlay>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Contact from "../../../models/Contact"
import CustomerContact from "../../../models/CustomerContact"
import ToastNotifications from "../../shared/mixins/ToastNotifications";

export default {
  name: 'ContactForm',
  mixins: [ToastNotifications],
  data() {
    return {
      form: {
        first_name: null,
        last_name: null,
        type: null,
        phone: null,
        mobile: null,
        //fax: null,
        email: null
      },
      contact_types: [
        {value: '', label: 'No Type Assigned'},
        {value: 'Sales', label: 'Sales'},
        {value: 'Accounting', label: 'Accounting'},
        {value: 'Territory Manager', label: 'Territory Manager'},
        {value: 'Owner', label: 'Owner'},
      ],
      saving: false
    };
  },
  methods: {
    save() {
      this.saving = true;
      this.createContact().then((contact) => {
        this.createCustomerContact(contact).then((customer_contact) => {
          if(this.form.email && this.form.email !== '') {
            this.inviteCustomerContact(customer_contact).then((customer_contact) => {
              this.$emit('onSave', customer_contact, contact);
              CustomerContact.api().export(customer_contact.id);
              this.saving = false;
              //this.quickSuccessToast('Contact Invited', 'An invite was sent to the contact. Make sure to check the spam folder.')
            }, (err) => {
              CustomerContact.api().remove(customer_contact.id);
              Contact.api().remove(contact.id);
              this.$emit('onSaveFail', err);
              this.saving = false;
              //this.quickSuccessToast('Contact could not be invited', err)
            });
          } else {
            this.$emit('onSave', customer_contact, contact);
            CustomerContact.api().export(customer_contact.id);
            this.saving = false;
          }
        }, () => {
          Contact.api().remove(contact.id);
          this.$emit('onSaveFail', 'Contact could be be created at this time please try again later.');
          //this.quickSuccessToast('Contact Invited', 'An invite was sent to the contact. Make sure to check the spam folder.')
          this.saving
                  = false;
        });
      }, () => {
        this.$emit('onSaveFail', 'Contact could be be created at this time please try again later.');
        //this.quickSuccessToast('Contact Invited', 'An invite was sent to the contact. Make sure to check the spam folder.')
        this.saving = false;
      });
    },
    createContact: function() {
      let payload = JSON.parse(JSON.stringify(this.form));
      payload.full_name = [payload.first_name, payload.last_name].join(' ');
      return Contact.api().create(payload).then((response) => {
        return response.entities.contacts[0];
      });
    },
    createCustomerContact: function(contact) {
      return CustomerContact.api().create({
        customer_id: localStorage.getItem('customer_id'),
        contact_id: contact.id
      }).then((response) => {
        return response.entities.customer_contacts[0];
      });
    },
    inviteCustomerContact: function(customer_contact) {
      return CustomerContact.api().invite(customer_contact.id).then((response) => {
        return response.entities.customer_contacts[0];
      });
    }
  }
}
</script>
